import { render, staticRenderFns } from "./ChurchForm.vue?vue&type=template&id=77f5b0a0&"
import script from "./ChurchForm.vue?vue&type=script&lang=js&"
export * from "./ChurchForm.vue?vue&type=script&lang=js&"
import style0 from "./ChurchForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChurchForm.vue"
export default component.exports